var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-hud"},[_c('v-popover',{attrs:{"placement":"right"}},[_c('c-icon',{attrs:{"icon":"info-circle"}}),_vm._v(" "),_c('template',{slot:"popover"},[_vm._t("default")],2)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }